import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_DANHSACHDONHANG } from "../actions/DanhSachDonHang/actionTypes";
import {
    getListDanhSachDonHangSuccess,
    getListDanhSachDonHangFailure,
} from "../actions/DanhSachDonHang";
import DonHangApi from "../service/DonHang/DonHangApi";

function* getListDanhSachDonHang(action) {
    try {
        sessionStorage.setItem("BanGhiDanhSachDonHang", action.dataSearch.iPageSize ?? 20);
        const response = yield call(DonHangApi.list, action.dataSearch);
        if (response.ok) {
            yield put(getListDanhSachDonHangSuccess(response.data));
        } else {
            yield put(getListDanhSachDonHangFailure());
        }
    } catch (error) {
        yield put(getListDanhSachDonHangFailure());
    }
}

function* watchGetRequest() {
    yield takeLatest(GET_LIST_DANHSACHDONHANG, getListDanhSachDonHang);
}

export default function* sagas() {
    yield all([watchGetRequest()]);
}
